import { Action, createReducer, on } from '@ngrx/store';
import * as allActions from './stock-correction.actions';

export const stockCorrectionFeatureKey = 'stock-correction';

export interface StockCorrectionState {
  reasonCodes: any;
  reasonCodeFilter: any;
  products: any;
  totalCount: number;
  piLocations: any;
  piProducts: any;
  piTotalCount: any;
  catalogEnabledBatches: Map<string, Array<any>>;
  allPiLocations: any;
}

export const initialState: StockCorrectionState = {
  reasonCodes: [],
  reasonCodeFilter: [],
  products: [],
  totalCount: 0,
  piLocations: [],
  piProducts: [],
  piTotalCount: 0,
  catalogEnabledBatches: new Map(),
  allPiLocations: [],
};

export const stockCorrectionReducer = createReducer(
  initialState,
  on(allActions.loadReasonCodesSuccess, (state: StockCorrectionState, data) => {
    return {
      ...state,
      reasonCodes: data.reasonCodes,
      reasonCodeFilter: data.reasonCodeFilter,
    };
  }),

  on(allActions.loadProductSuccess, (state: StockCorrectionState, data) => {
    return { ...state, products: data.products };
  }),

  on(allActions.loadProductTotalCount, (state: StockCorrectionState, data) => {
    return {
      ...state,
      totalCount: data.totalCount,
    };
  }),

  on(allActions.loadPiLocationsSuccess, (state: StockCorrectionState, data) => {
    return { ...state, piLocations: data.piLocations };
  }),

  on(allActions.loadPiProductsSuccess, (state: StockCorrectionState, data) => {
    return {
      ...state,
      piProducts: data.piProducts,
      piTotalCount: data.totalCount,
    };
  }),

  on(allActions.cancelPiCountSuccess, (state: StockCorrectionState, data) => {
    return {
      ...state,
      piProducts: [],
      piTotalCount: 0,
    };
  }),
  on(allActions.savePiCountSuccess, (state: StockCorrectionState, data) => {
    return {
      ...state,
      piProducts: [],
      piTotalCount: 0,
    };
  }),
  on(allActions.completePiCountSuccess, (state: StockCorrectionState, data) => {
    return {
      ...state,
      piProducts: [],
      piTotalCount: 0,
    };
  }),
  on(
    allActions.getAllPiLocationsSuccess,
    (state: StockCorrectionState, data) => {
      return { ...state, allPiLocations: data.locations };
    }
  )
);
